import { render, staticRenderFns } from "./IntroPen2.vue?vue&type=template&id=41bde6fe&scoped=true&"
import script from "./IntroPen2.vue?vue&type=script&lang=js&"
export * from "./IntroPen2.vue?vue&type=script&lang=js&"
import style0 from "./IntroPen2.vue?vue&type=style&index=0&id=41bde6fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bde6fe",
  null
  
)

export default component.exports